import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      borderColor: theme.palette.secondary.dark,
      borderStyle: "solid",
      borderWidth: 1,
      width: "350px",
      [theme.breakpoints.down("sm")]: {
        width: "98%",
        right: "1%",
      },
      [theme.breakpoints.up("sm")]: {
        width: "350px",
        right: theme.spacing(2),
      },
      right: theme.spacing(2),
      bottom: theme.spacing(2),
      position: "fixed",
      zIndex: theme.zIndex.drawer + 1,
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
    },
    cardActions: {
      flexDirection: "row-reverse",
    },
    title: {
      marginTop: theme.spacing(1),
      textAlign: "center",
      fontSize: 16,
      fontWeight: 600,
      color: theme.palette.secondary.contrastText,
    },
    subheader: {
      fontSize: 14,
      fontWeight: 600,
      color: theme.palette.secondary.contrastText,
    },
    button: {
      borderColor: theme.palette.secondary.contrastText,
      color: theme.palette.secondary.contrastText,
    },
  })
);
